:root {
  -webkit-font-smoothing: antialiased;
  background-color: #ffffff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:-webkit-autofill:active {
  padding-inline: 16px;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
}

input:focus {
  outline: none;
}
